import { Icon } from '@shopify/polaris';
import { MenuIcon, SearchIcon } from '@shopify/polaris-icons';
import { StatusBadge } from '../components/StatusBadge';
import { PakoLogo } from '../components/PakoLogo';

function roleLabel(role?: 'admin' | 'viewer' | null) {
  return role === 'viewer' ? 'Перегляд' : 'Адмін';
}

export function TopBar({
  searchValue,
  onSearchChange,
  environmentLabel,
  environmentStatus,
  role,
  onLogout,
  onOpenNavigation,
}: {
  searchValue: string;
  onSearchChange: (value: string) => void;
  environmentLabel: string;
  environmentStatus: string;
  role?: 'admin' | 'viewer' | null;
  onLogout: () => void;
  onOpenNavigation: () => void;
}) {
  return (
    <header className="admin-topbar">
      <div className="admin-topbar__header-row">
        <div className="admin-topbar__brand-row">
          <button
            type="button"
            className="admin-topbar__menu"
            onClick={onOpenNavigation}
            aria-label="Відкрити меню"
          >
            <Icon source={MenuIcon} />
          </button>
          <div className="admin-topbar__mobile-logo">
            <PakoLogo size={36} />
          </div>
          <div className="admin-topbar__brand-copy">
            <div className="admin-topbar__title">Pako AdminApp</div>
            <div className="admin-topbar__meta">
              <span className="admin-topbar__role">Роль: {roleLabel(role)}</span>
            </div>
          </div>
        </div>
        <div className="admin-topbar__actions">
          <div
            className="admin-topbar__env"
            aria-label={`Стан магазину: ${environmentLabel}`}
            title={`Стан магазину: ${environmentLabel}`}
          >
            <span className="admin-topbar__env-label">Стан магазину</span>
            <StatusBadge status={environmentStatus} label={environmentLabel} />
          </div>
          <button type="button" className="admin-topbar__logout" onClick={onLogout}>Вийти</button>
        </div>
      </div>
      <div className="admin-topbar__search">
        <span className="admin-topbar__search-icon">
          <Icon source={SearchIcon} />
        </span>
        <input
          type="search"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Пошук по товарах, замовленнях, логах"
        />
      </div>
    </header>
  );
}
